var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"freeproduct"},[_c('h2',[_vm._v("Learn about free RiXtrema's products")]),_c('button',{staticClass:"button learnblock",on:{"click":_vm.down}},[_c('i',{staticClass:"fa fa-search",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }